import { useProduct } from '@/entities/product';
import { useAutoshipCustomerStatus } from '@/features/autoship-customer-status';
import { getOneTimePrice, PriceDisplay } from '@/widgets/product-details/price/lib';

export const useAutoshipPrice = (): PriceDisplay | null => {
    const { product } = useProduct();
    const { isFirstAutoshipEligible, isLoading, isError } = useAutoshipCustomerStatus();

    if (!product || isLoading || isError) return null;

    const price = isFirstAutoshipEligible ? product.autoship.firstTimePrice : product.autoship.recurringPrice;

    if (price == null) return null;

    const { effectivePrice } = getOneTimePrice(product.price);

    return { values: [price, effectivePrice], variant: 'disabled' };
};
